enum SystemActions {
    GET_SETTINGS = "systemFetchSettings",
    UPDATE_SETTINGS = "systemUpdateSettings",
    CREATE_ROLE = "systemCreateRole",
    DELETE_ROLE = "systemDeleteRole",
    OAUTH_AMAZON = 'systemSetAmazonToken',
    CHECK_ROLE_CONSTRAINTS = 'systemCheckRoleConstraints',
    REFRESH_MAILS = 'systemRefreshMails',
    FETCH_MAILS = 'systemFetchMails',
    CREATE_MAIL = 'systemCreateMail',
    UPDATE_MAIL = 'systemUpdateMail',
    DELETE_MAIL = 'systemDeleteMail',
    REFRESH_TRANSLATIONS = 'systemRefreshTranslations',
    FETCH_TRANSLATIONS = 'systemFetchTranslations',
    UPDATE_TRANSLATION = 'systemUpdateTranslation',
    CREATE_TRANSLATION = 'systemCreateTranslation',
    DELETE_TRANSLATION = 'systemDeleteTranslation',
    FETCH_API_LOGS = 'systemFetchApiLogs',
    REFRESH_API_LOGS = 'systemRefreshApiLogs',
    CLEAR_API_LOGS = 'systemClearApiLogs',
    FETCH_ERROR_LOGS = 'systemFetchErrorLogs',
    REFRESH_ERROR_LOGS = 'systemRefreshErrorLogs',
    CLEAR_ERROR_LOGS = 'systemClearErrorLogs',
}

enum SystemMutation {
    SET_RENDER_UPDATE = "systemListRenderNeeded",
    SET_LIST_RESULT = "systemListResult",
    SET_MAIL_LIST_RESULT = "systemMailListResult",
    REFRESH_MAIL_LIST = "systemRefreshMailList",
    SET_TRANSLATIONS_LIST_RESULT = "systemTranslationsListResult",
    REFRESH_TRANSLATIONS_LIST = "systemRefreshTranslationsList",
    SET_API_LOGS_LIST_RESULT = "systemApiLogsListResult",
    REFRESH_API_LOGS_LIST = "systemRefreshApiLogsList",
    SET_ERROR_LOGS_LIST_RESULT = "systemErrorLogsListResult",
}

export {SystemActions, SystemMutation};
